














































































































































import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import { namespace } from "vuex-class";
import postalCodeApi from "@/api/postalCodeApi";
import Location from "@/model/location";
import Contract from "@/model/contract";
import contractApi from "@/api/contractApi";
import PaginateModel from "@/model/paginate";
import ContractEdit from "@/components/contract/contractEdit.vue";
import { USER_ROLE } from "@/model/user";
import store from "@/store";
const routerStore = namespace("Router");
const auth = namespace("Auth");
@Component({
  name: "ContractList",
  components: {
    QUserSelect,
    QCalendar,
    QTableHeader,
    QPaginate,
    ContractEdit,
  },
})
export default class ContractList extends Vue {
  @auth.Getter
  getCurrentyCompany!: Company;
  @routerStore.Getter
  public getPreviousRouter;
  @routerStore.Getter
  public getSearchParameters;

  public postalCode: Location[] = [];
  public contractList: Contract[] = null;
  public dateConfig = {};
  public userRole = USER_ROLE;

  public search: any = {};
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public headers = [
    { id: "order", name: "", order: "" },
    { id: "", name: "契約者名" },
    { id: "", name: "ユーザー名" },
    { id: "move_in_date", name: "入居日", order: "desc" },
    { id: "no", name: "契約番号" },
    { id: "property_name", name: "契約物件", order: "" },
    { id: "contractor.username", name: "契約担当者", order: "" },
    { id: "", name: "" },
  ];

  get companyId() {
    return this.getCurrentyCompany.id;
  }

  get getArea() {
    this.search.prefecture;
    if (!this.search.prefecture) {
      return [];
    }
    return _.chain(this.postalCode)
      .filter((item) => item.prefecture === this.search.prefecture.trim())
      .uniqBy("area")
      .value();
  }
  get getPrefecture() {
    return _.uniqBy(this.postalCode, "prefecture");
  }

  mounted() {
    if( this.getPreviousRouter.matched[1] && this.getPreviousRouter.matched[1].name == "admin.contract-router"
      && this.getSearchParameters && this.getSearchParameters.contractList
    ) {
      this.search = this.getSearchParameters.contractList;
    } else {
      this.initalSearch(null);
    }
    this.listPostalCode();
    this.$nextTick(() => {
      this.getList(this.search);
    });
  }

  public async listPostalCode() {
    this.postalCode = await postalCodeApi.listOfProperty({
      notLoading: true
    });
  }
  public searchInital() {
    return {
      move_in_date_from: null,
      move_in_date_to: null,
      area: null,
      prefecture: null,
      name: null,
      contractor_id: null,
      keywords: null,
      statuses: ["1"],
      sort: "move_in_date",
      direction: "desc",
      property_name: "",
    };
  }
  public clear() {
    this.search = this.searchInital();
    store.dispatch("Router/setSearchParameters", {contractList: null});
    this.changeState();
    this.doSearch(this.search);
  }

  public doSearch(query: any): void {
    this.search = { ...this.search, ...query };
    store.dispatch("Router/setSearchParameters", {contractList: {...this.search}});
    this.getList(this.search);
  }

  public onSearch(): void {
    this.changeState();
    this.doSearch(this.search);
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    query.statuses && (query.statuses = [...query.statuses]);
    this.search = {
      ...this.searchInital(),
      ...query,
    };
    if (Object.keys(query).length > 0) {
      store.dispatch("Router/setSearchParameters", {contractList: this.search});
    } else {
      store.dispatch("Router/setSearchParameters", {contractList: null});
    }
  }

  public tranformQuery(query) {
    const queryParameters = Object.assign({}, query);
    if (query.statuses.includes("1") && query.statuses.includes("0")) {
      queryParameters.statuses = [0];
    } else if (query.statuses.includes("1")) {
      queryParameters.statuses = [0, 1];
    } else if (query.statuses.includes("0")) {
      queryParameters.statuses = [0];
    } else {
      queryParameters.statuses = [];
    }
    return queryParameters;
  }

  public async getList(query) {
    const queryParameters = this.tranformQuery(query);
    const result = await contractApi.index(queryParameters);
    this.pagination = result.paginate;
    this.contractList = result.list;
  }
}
